import React, { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import BackOfficeSidebar from './BackOfficeSidebar';
import { WebShellProvider, useWebShell } from './WebShellContext';
import { useLayoutSize } from '../../theme';

type Props = {
  children: React.ReactNode;
};

export default function BackOfficeSidebarLayout({ children }: Props) {
  const { useSidebarNav } = useLayoutSize();

  if (!useSidebarNav) return <>{children}</>;

  return (
    <WebShellProvider>
      <BackOfficeSidebarLayoutInner>{children}</BackOfficeSidebarLayoutInner>
    </WebShellProvider>
  );
}

function BackOfficeSidebarLayoutInner({
  children,
}: {
  children: React.ReactNode;
}) {
  const styles = useMemo(() => createStyles(), []);
  const { header } = useWebShell();

  return (
    <View style={styles.root}>
      {header ? <View style={styles.header}>{header}</View> : null}
      <View style={styles.container}>
        <BackOfficeSidebar />
        <View style={styles.content}>{children}</View>
      </View>
    </View>
  );
}

const createStyles = () =>
  StyleSheet.create({
    root: {
      flex: 1,
    },
    header: {
      width: '100%',
      flexShrink: 0,
    },
    container: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'stretch',
    },
    content: {
      flex: 1,
      minWidth: 0,
    } as any,
  });
